export default (event) => {
  try {
    window.sa_event(event);
  } catch {}
};
